import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "p-i-conditions-panel__icon" }
const _hoisted_3 = { class: "p-i-conditions-panel__name" }
const _hoisted_4 = {
  key: 0,
  class: "p-i-conditions-panel__name__kind-wrapper"
}
const _hoisted_5 = { class: "p-i-conditions-panel__name__kind" }
const _hoisted_6 = {
  class: "p-i-conditions-panel__name__text",
  "data-translate-skip": ""
}
const _hoisted_7 = { class: "p-i-conditions-panel__id" }
const _hoisted_8 = { class: "p-i-conditions-panel__point" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconInvestedRounded = _resolveComponent("IconInvestedRounded")!
  const _component_SmallText = _resolveComponent("SmallText")!

  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.conditionsDetail.url,
    class: _normalizeClass(["p-i-conditions-panel", { 'has-kind': _ctx.kindResult }])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconInvestedRounded, {
        type: _ctx.iconType,
        "icon-size": 36,
        "bg-color": _ctx.colorCode,
        "icon-color": "#ffffff"
      }, null, 8, ["type", "bg-color"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.kindResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.kindResult), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.name), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_SmallText, null, {
        default: _withCtx(() => [
          _createTextVNode("ID: " + _toDisplayString(_ctx.id), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_SmallText, {
        "font-size": 14,
        color: "#616161",
        "data-translate-skip": ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("+ " + _toDisplayString(_ctx.addComma(_ctx.points)) + _toDisplayString(_ctx.point), 1)
        ]),
        _: 1
      })
    ])
  ], 10, _hoisted_1))
}